<script lang="ts" setup>
import { onBeforeUnmount, ref, watch } from 'vue'

import AnimatedLogoLoader from '@/components/createdUi/AnimatedLogoLoader.vue'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'

// Инициализация хранилища состояний
const feedbackStore = useFeedbackStore()

/*
 * Длительность дебаунса на скрытие. Между последовательными fetch-методами
 * в проекте обычно проходит 20–100 мс — для пользователя это выглядело
 * как «мигающий» лоадер.
 */
const HIDE_DELAY_MS = (feedbackStore as any).loaderDebounceDelay ?? 700

const visible = ref(false)
let timeoutId: any = null

watch(visible, val => {
  if (val) {
    document.documentElement.classList.add('loader-overlay-active')
  } else {
    document.documentElement.classList.remove('loader-overlay-active')
  }
}, { immediate: true })

onBeforeUnmount(() => {
  document.documentElement.classList.remove('loader-overlay-active')
})

/*
 * Асимметричный дебаунс: лоадер показывается мгновенно,
 * а скрывается с задержкой HIDE_DELAY_MS, чтобы избежать мерцания
 * между последовательными запросами.
 */
watch(() => feedbackStore.isGlobalLoading, newVal => {
  if (newVal) {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
    visible.value = true
  } else {
    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        visible.value = false
        timeoutId = null
      }, HIDE_DELAY_MS)
    }
  }
}, { immediate: true })
</script>

<template>
  <Teleport to="body">
    <div v-if="visible" class="loader_overlay">
      <AnimatedLogoLoader :size="120" />
    </div>
  </Teleport>
</template>

<style scoped>
.loader_overlay {
  position: fixed;
  z-index: 100000;
  inset: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgba(15, 18, 28, 0.72);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: opacity 0.15s ease-in-out;
}

:global(html.loader-overlay-active),
:global(html.loader-overlay-active body) {
  overflow: hidden !important;
}
</style>
